import axios from 'axios'
import Setting from "@/setting";
import db from "@/libs/utils/db";
import utils from "@/libs/utils/comm";
import store from '@/store/index';
import md5 from "@/libs/vendor/md5.js";
import router from "@/router";
//import cookies from "@/libs/utils/util.cookies";
// 创建一个 axios 实例
let service = axios.create({
    baseURL: Setting.apiBaseURL,
    timeout: 100000 // 请求超时时间
});

axios.defaults.withCredentials = true;// 携带cookie


// 请求拦截器
service.interceptors.request.use(
    async config => {
        let post = utils.upHeaders();
        for(var i in post) {
            config.headers[i] = post[i];
        }
        return config;
    },
    error => {
        // 发送失败
        console.log(error);
        Promise.reject(error);
    }
);


// 响应拦截器
service.interceptors.response.use(
    response => {
        const code = response.data.code;
        switch (code) {
            case 200:
                return response.data;
            //重新登录
            case -99:
                db.removeStorageSync("adminUser");
                if (router.currentRoute.path !== '/login') {
                    router.replace("/login").catch(() => {});
                }
                return Promise.reject(response.data);
            default:
                return response.data;
        }
    },
    error => {
        console.log(error);
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '请求错误';
                    break;
                case 401:
                    error.message = '未授权，请登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = `请求地址出错: ${error.response.config.url}`;
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器内部错误';
                    break;
                case 501:
                    error.message = '服务未实现';
                    break;
                case 502:
                    error.message = '网关错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网关超时';
                    break;
                case 505:
                    error.message = 'HTTP版本不受支持';
                    break;
                default:
                    break;
            }
        }
        return Promise.reject(error)
    }
);
export default service;
